<template>
    <div style="width: unset">
        <button
            v-if="btnText"
            class="btn sm:inline-flex py-3 tx-18 w-full"
            style="
                background-color: #000;
                color: #dbfe54;
                font-weight: 600;
                max-height: 47px;
                min-width: 168px;
            "
            @click="validateUser($event)"
        >
            {{ btnText }}
        </button>
        <div v-else>
            <div>
                <p class="text-adviser-button" :style="{ color: displayText }">
                    ¡Asesor disponible ahora!
                </p>
            </div>
            <button
                class="btn btn--whatsapp sm:inline-flex py-3 wobble-hor-bottom"
                @click="validateUser($event)"
            >
                Enviar&nbsp;<strong>WhatsApp</strong
                ><img
                    class="icon_whatsapp ml-2"
                    width="16px"
                    src="/assets/images/helpers/icon-whatsapp.svg"
                    alt=""
                />
            </button>
        </div>
        <div
            v-if="show"
            class="overlay active overlay--auth backdrop-blur pt-10"
        >
            <div class="wrapper-lightbox" style="max-width: 560px">
                <div class="close-modal" @click="closeModal(true)">
                    <span class="tx-dark-ad">
                        <i class="fas fa-times"></i>
                    </span>
                </div>
                <div class="lightbox">
                    <div class="p-4 md:py-3 md:px-3">
                        <p v-if="!btnText" class="tx-20 weight-500 opacity-90">
                            Comunícate con el vendedor
                        </p>
                        <p class="tx-18 opacity-90 m-0 text-center weight-600">
                            {{ product.brand.title }} {{ product.model.title }}
                            {{ product.year }}
                        </p>
                    </div>
                    <form
                        id="interested_prospect_form"
                        @submit.prevent="haddlerSubmit()"
                    >
                        <div class="container">
                            <div class="form-group col-16">
                                <!-- <label class="form-label form-label--big" for="">Nombre</label> -->
                                <input
                                    v-model="name"
                                    class="form-input"
                                    type="text"
                                    placeholder="Nombre"
                                />
                                <small
                                    v-if="errorsBag.name"
                                    style="color: red"
                                    >{{ errorsBag.name[0] }}</small
                                >
                            </div>
                            <div class="form-group col-16">
                                <!-- <label class="form-label form-label--big" for="">Celular</label> -->
                                <the-mask
                                    v-model="phone"
                                    class="form-input"
                                    type="tel"
                                    placeholder="Celular"
                                    :masked="false"
                                    mask="##-##-##-##-##"
                                ></the-mask>
                                <small
                                    v-if="errorsBag.phone"
                                    style="color: red"
                                    >{{ errorsBag.phone[0] }}</small
                                >
                            </div>
                            <div class="form-group col-16">
                                <!-- <label class="form-label form-label--big" for="">Email</label> -->
                                <input
                                    v-model="email"
                                    class="form-input"
                                    type="email"
                                    placeholder="Email"
                                />
                                <small
                                    v-if="errorsBag.email"
                                    style="color: red"
                                    >{{ errorsBag.email[0] }}</small
                                >
                            </div>
                            <div class="form-group col-16">
                                <select
                                    id="down_payment"
                                    v-model="down_payment"
                                    class="form-input"
                                >
                                    <option
                                        value=""
                                        disabled
                                        selected
                                        style="color: lightgray"
                                    >
                                        Seleccionar enganche
                                    </option>
                                    <option value="Compra de contado">
                                        Compra de contado
                                    </option>
                                    <option value="$100,000 a $150,000">
                                        $100,000 a $150,000
                                    </option>
                                    <option value="$150,000 a $250,000">
                                        $150,000 a $250,000
                                    </option>
                                    <option value="$250,000 a $350,000">
                                        $250,000 a $350,000
                                    </option>
                                    <option value="Más de $350,000">
                                        Más de $350,000
                                    </option>
                                </select>
                                <small
                                    v-if="errorsBag.down_payment"
                                    style="color: red"
                                    >{{ errorsBag.down_payment[0] }}</small
                                >
                            </div>
                            <div class="form-group col-16">
                                <textarea
                                    v-if="btnText"
                                    id="comments"
                                    v-model="comments"
                                    class="form-input"
                                    placeholder="Comentarios"
                                    maxlength="500"
                                    style="min-height: 170px"
                                ></textarea>
                            </div>
                            <div class="form-group col-16">
                                <input
                                    type="checkbox"
                                    name="is_a_trade_in"
                                    id="is_a_trade_in"
                                    v-model="isATradeIn"
                                />
                                <label for="is_a_trade_in"
                                    >Quiero dejar auto a cuenta</label
                                >
                            </div>
                            <div v-if="isATradeIn">
                                <div class="form-group col-16">
                                    <input
                                        type="text"
                                        name="tradein_year"
                                        id="tradein_year"
                                        class="form-input"
                                        placeholder="Año"
                                        v-model="tradeinYear"
                                    />
                                    <small
                                        v-if="errorsBag.tradein_year"
                                        style="color: red"
                                        >{{ errorsBag.tradein_year[0] }}</small
                                    >
                                </div>
                                <div class="form-group col-16">
                                    <input
                                        type="text"
                                        name="tradein_brand"
                                        id="tradein_brand"
                                        class="form-input"
                                        placeholder="Marca"
                                        v-model="tradeinBrand"
                                    />
                                    <small
                                        v-if="errorsBag.tradein_brand"
                                        style="color: red"
                                        >{{ errorsBag.tradein_brand[0] }}</small
                                    >
                                </div>
                                <div class="form-group col-16">
                                    <input
                                        type="text"
                                        name="tradein_model"
                                        id="tradein_model"
                                        class="form-input"
                                        placeholder="Modelo"
                                        v-model="tradeinModel"
                                    />
                                    <small
                                        v-if="errorsBag.tradein_model"
                                        style="color: red"
                                        >{{ errorsBag.tradein_model[0] }}</small
                                    >
                                </div>
                                <div class="form-group col-16">
                                    <the-mask
                                        v-model="tradeinKilometers"
                                        class="form-input"
                                        type="text"
                                        placeholder="Kilometraje"
                                        :masked="false"
                                        mask="######"
                                    ></the-mask>
                                    <small
                                        v-if="errorsBag.tradein_kilometers"
                                        style="color: red"
                                        >{{
                                            errorsBag.tradein_kilometers[0]
                                        }}</small
                                    >
                                </div>
                            </div>
                            <input
                                v-if="btnText"
                                :disabled="isLoading"
                                class="btn weight-700 tx-16 flex mx-a w-full"
                                :class="{ 'opacity-50': isLoading }"
                                style="background-color: #000; color: #dbfe54"
                                type="submit"
                                :value="btnText"
                            />
                            <input
                                v-else
                                class="btn--whatsapp btn weight-700 tx-16 flex mx-a"
                                :disabled="isLoading"
                                :class="{ 'opacity-50': isLoading }"
                                type="submit"
                                value="Enviar whatsapp"
                            />
                            <br />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { VMoney } from "v-money";

export default {
    props: ["cellphone", "product", "user_id", "message", "btn-text", "user_name", "user_phone"],
    data() {
        return {
            show: false,
            formData: null,
            err: {},
            name: "",
            phone: "",
            email: "",
            down_payment: "",
            comments: "",
            errorsBag: {},
            isLoading: false,
            displayText: "transparent",
            isATradeIn: false,
            tradeinYear: "",
            tradeinBrand: "",
            tradeinModel: "",
            tradeinKilometers: "",
        };
    },
    mounted() {
        this.showDescriptionAssesor();
    },
    directives: { money: VMoney },
    methods: {
        validateUser(event) {
            if (this.user_id > 0) {
                this.name = this.user_name
                this.phone = this.user_phone
            }
            this.show = true;
            event.preventDefault();
            this.registerClick(event);
        },
        async registerClick(event) {
            const btn = event.target.innerText;

            let type = "";

            if (btn == "Me interesa") type = "interested";
            else type = "whatsapp";

            await axios
                .post("/client/stats/register-click/", {
                    mkt_vehicle_id: this.product.id,
                    button: type,
                })
                .then((response) => {})
                .catch((error) => {
                    console.error(error);
                });
        },
        showForm(event) {
            event.preventDefault();
            this.show = true;
        },

        async haddlerSubmit() {
            let vm = this;
            vm.isLoading = true;
            vm.errorsBag = {};
            if (this.phone.length < 10) {
                vm.isLoading = false;
                return vm.$swal({
                    icon: "error",
                    text: "El número debe ser de 10 dígitos",
                });
            }

            vm.formData = new FormData();
            vm.formData.append("name", vm.name);
            vm.formData.append("phone", vm.phone);
            vm.formData.append("user_id", vm.user_id);
            vm.formData.append("message", vm.message);

            vm.formData.append("email", vm.email);
            vm.formData.append("down_payment", vm.down_payment);
            vm.formData.append("comments", vm.comments);

            vm.formData.append(
                "interested_prospect",
                this.btnText?.length > 0 ? 1 : 0
            );
            vm.formData.append("state_id", this.$cookies.get("stateUser") || 0);

            vm.formData.append("is_a_trade_in", vm.isATradeIn ? 1 : 0);
            vm.formData.append("tradein_year", vm.tradeinYear);
            vm.formData.append("tradein_brand", vm.tradeinBrand);
            vm.formData.append("tradein_model", vm.tradeinModel);
            vm.formData.append("tradein_kilometers", vm.tradeinKilometers);
            vm.formData.append("dealership_phone", vm.cellphone);

            let data = await axios
                .post("/client/stats/whatsapp/" + vm.product.id, vm.formData)
                .then((response) => {
                    let message = "?text=" + vm.message;

                    if (!vm.btnText)
                        this.openWhatsapp(
                            `https://wa.me/${this.cellphone}?text=${this.message}`
                        );
                    vm.closeModal();
                    if (vm.btnText)
                        vm.$swal({
                            icon: "success",
                            title: "¡Tu solicitud ha sido enviada!",
                            text: "En breve un agente de esta agencia se pondrá en contacto contigo.",
                            closeOnConfirm: true,
                            cancelButton: false,
                            confirmButtonText: "Aceptar",
                        });
                    vm.isLoading = false;
                })
                .catch((error) => {
                    console.error(error);
                    vm.isLoading = false;
                    if ((error.response.status = 422))
                        vm.errorsBag = error.response.data.errors;
                });
        },
        resetForm() {
            this.errorsBag = {};
            this.name = "";
            this.phone = "";
            this.email = "";
            this.down_payment = "";
            this.comments = "";
            this.isATradeIn = false;
            this.tradeinYear = "";
            this.tradeinBrand = "";
            this.tradeinModel = "";
            this.tradeinKilometers = "";
            document
                .getElementById("interested_prospect_form")
                .querySelector("select > option:first-child").selected = true;
        },
        closeModal(buttonClose = false) {
            if (buttonClose) {
                return this.$swal({
                            title: "¡No te pierdas tu próximo auto!",
                            text: "Deja tus datos y un especialista se pondrá en contacto contigo para mostrarte opciones personalizadas",
                            closeOnConfirm: true,
                            cancelButton: true,
                            confirmButtonText: "Volver",
                            cancelButtonText: "Salir",
                            cancelButtonColor: "#000",
                            showCancelButton: true,
                        }).then((result) => {
                            if (!result.isConfirmed) {
                                this.resetForm();
                                this.show = false;
                            }
                        });
            }
            this.resetForm();
            this.show = false;
        },
        openWhatsapp(url) {
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
        },
        showDescriptionAssesor() {
            setTimeout(() => {
                this.displayText = "lightslategray";
            }, 5000);
        },
    },
};
</script>
<style>
.swal2-styled.swal2-cancel {
    color: #dcfe54 !important;
    font-weight: bold !important;
}
</style>
